import { Routes } from "@angular/router";
import { authGuard } from "../guard/auth.guard";
import { registerGuard } from "../guard/register.guard";

export const content: Routes = [
  {
    path: "dashboard",
    canActivate: [registerGuard],
    loadChildren: () => import("../../components/dashboard/dashboard.module").then((m) => m.DashboardModule),
  },
  {
    path: "subscription",
    canActivate: [registerGuard],
    loadChildren: () => import("../../components/subscription/subscription.module").then((m) => m.SubscriptionModule),
  },
    {
    path: "manage-users",
    canActivate: [registerGuard],
    loadChildren: () => import("../../components/manage-users/manage-users.module").then((m) => m.ManageUsersModule),
  },

  {
    path: "transaction",
    canActivate: [registerGuard],
    loadChildren: () => import("../../components/transaction/transaction.module").then((m) => m.TransactionModule),
  },
  {
    path: "subscription-plans",
    canActivate: [registerGuard],
    loadChildren: () => import("../../components/subscription-plans/subscription-plans.module").then((m) => m.SubscriptionPlansModule),
  },
  {
    path: "registration-List",
    loadChildren: () => import("../../components/registration-list/registration-list.module").then((m) => m.RegistrationListModule),
  },
  {
    path: "whatsapp-template",
    canActivate: [registerGuard],
    loadChildren: () => import("../../components/whatsapp-template/whatsapp-template.module").then((m) => m.WhatsappTemplateModule),
  },
  {
    path: "masters",
    canActivate: [registerGuard],
    loadChildren: () => import("../../components/masters/masters.module").then((m) => m.MastersModule),
  },
  {
    path: "display-board-registration",
    canActivate: [registerGuard],
    loadChildren: () => import("../../components/display-board-registration/display-board-registration.module").then((m) => m.DisplayBoardRegistrationModule),
  },
   {
    path: "whatsapp-campaign",
    canActivate: [registerGuard],
    loadChildren: () => import("../../components/whatsapp-campaign/whatsapp-campaign.module").then((m) => m.WhatsappCampaignModule),
  },
     {
    path: "whatsapp-report",
    canActivate: [registerGuard],
    loadChildren: () => import("../../components/whatsapp-report/whatsapp-report.module").then((m) => m.WhatsappReportModule),
  },
    {
    path: "inbox",
    canActivate: [registerGuard],
    loadChildren: () => import("../../components/inbox/inbox.module").then((m) => m.InboxModule),
  },
    {
    path: "messagify-user",
    canActivate: [registerGuard],
    loadChildren: () => import("..//..//components/messagify-user/messagify-user.module").then((m) => m.MessagifyModule),
  },
  {
    path: "miniz-user-registration",
    canActivate: [registerGuard],
    loadChildren: () => import("../../components/miniz-user-registration/miniz-user-registration.module").then((m) => m.MinizUserRegistrationModule),
  },
  {
    path: "support-tickets",
    canActivate: [registerGuard],
    loadChildren: () => import("../../components/support-tickets/support-tickets.module").then((m) => m.SupportTicketsModule),
  },
    {
    path: "monthly-expiring-subscriptions",
    canActivate: [registerGuard],
    loadChildren: () => import("../../components/monthly-expiring-subscriptions/monthly-expiring-subscriptions.module").then((m) => m.MonthlyExpiringSubscriptionsModule),
  },
    {
    path: "send-notification",
    canActivate: [registerGuard],
    loadChildren: () => import("../../components/send-notification/send-notification.module").then((m) => m.SendNotificationModule),
  },


];
